<script lang="ts" setup>

</script>

<template>
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.608398" width="16" height="16" rx="8" fill="#ED0A34"/>
    <path d="M7.60888 4.65214C6.31025 4.80068 5.01619 5.87718 4.96278 7.41493C4.92921 8.35384 5.18939 9.05821 6.06151 9.256C6.43996 8.57195 5.93943 8.42107 5.8616 7.92621C5.5419 5.89829 8.14451 4.51533 9.50647 5.93112C10.4488 6.91147 9.82845 9.92754 8.30855 9.61405C6.85274 9.31463 9.0212 6.91381 7.85914 6.4424C6.91454 6.05933 6.41249 7.61428 6.86037 8.38667C6.5979 9.7149 6.03251 10.9665 6.26141 12.6325C7.00382 12.0805 7.25408 11.0236 7.45933 9.92129C7.83244 10.1535 8.03158 10.395 8.5077 10.4326C10.2634 10.5717 11.2438 8.63684 11.0042 6.85205C10.7914 5.26974 9.2501 4.46452 7.60888 4.65214Z" fill="white"/>
  </svg>
</template>